import React, { FC, ErrorInfo, useMemo } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'

export interface ErrorBoundaryProps {
  notifyError?: (error: Error, info: ErrorInfo) => void
}

export interface LoadingProps {
  apiStatus: string
}

export const Loading: FC<LoadingProps> = React.memo(({ apiStatus }) => {
  const isLoading = useMemo(() => apiStatus === 'pending', [apiStatus])

  const useStyles = makeStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      '& > * ': {
        marginTop: -100,
      },
    },
  })

  const classes = useStyles()

  return <div className={classes.root}>{isLoading && <CircularProgress />}</div>
})
